import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function organisationReducer(state = initialState.organisation, action) {
  const organisation = { ...state };

  switch (action.type) {
    case types.GET_ORGANISATION_SUCCESS:
      return action.data;

    case types.GET_AGE_CATEGORIES_SUCCESS:
      organisation.availableAgeCategories = action.ageCategories;
      return organisation;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/organisationReducer.js